import { Check } from '@mui/icons-material';
import { Button, ButtonProps } from '@mui/material';

interface Props extends ButtonProps {
  label: string;
}

export const BookingStateApplyButton = (props: Props) => {
  return (
    <Button
      {...props}
      variant="contained"
      sx={{
        alignSelf: 'flex-end',
        marginTop: '1rem'
      }}
      startIcon={<Check />}
    >
      {props.label}
    </Button>
  );
};
